module.exports = __webpack_public_path__ + "static/media/dart-logo.19474dd4.svg";